export const enum Currency {
  EURO = 'EUR',
  CHF = 'CHF',
  DOLLAR = 'DOL'
}
